import React, { useState } from "react";
import { Input } from "@windmill/react-ui";
import { IoEye, IoEyeOff } from "react-icons/io5";

const InputArea = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  icon,
  onChange,
}) => {
  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength} !`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength} !`,
    },
    validate: (value) => {
      if (
        typeof value === "string" &&
        value.trim() === "" &&
        required !== false
      ) {
        return `${label} is required!`;
      }
      if (type === "number") {
        const numericValue = Number(value);
        if (isNaN(numericValue) || numericValue <= 0) {
          return `${label} must be greater than 0!`;
        }
      }
      return true;
    },
  };
  const handleInput = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length > maxLength) {
      event.target.value = inputValue.slice(0, maxLength);
      return;
    }
  };

  const [inputType, setInputType] = useState("password");

  const togglePasswordVisibility = () => {
    setInputType((prevType) => (prevType === "password" ? "text" : "password"));
  };

  return (
    <div className="relative">
      <Input
        {...register(`${name}`, validation)}
        defaultValue={defaultValue}
        type={type === "password" ? inputType : type}
        placeholder={placeholder}
        onInput={handleInput}
        name={name}
        value={value}
        autoComplete="off"
        readOnly={readOnly}
        style={{ width: "100%" }}
        className="border h-12 text-sm focus:outline-none block border-transparent focus:bg-white"
      />
      {icon === "true" && (
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute text-gray-500"
          style={{
            fontSize: "18px",
            right: "5%",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          {inputType === "password" ? <IoEye /> : <IoEyeOff />}
        </button>
      )}
    </div>
  );
};

export default InputArea;
